"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeSelectors = normalizeSelectors;

function normalizeSelectors(selectors) {
  var normalizedSelectors = {
    success: {},
    error: {}
  };

  if (selectors) {
    if (selectors.success) {
      normalizedSelectors.success = selectors.success;
    } else if (!selectors.error) {
      normalizedSelectors.success = selectors;
    } else {
      normalizedSelectors.success = {};
    }

    if (selectors.error) {
      normalizedSelectors.error = selectors.error;
    }
  }

  return normalizedSelectors;
}